(function () {
  'use strict';
  var HANDLE = 'camiseta-para-hombre-con-capucha-y-cobertura-facial';
  var root = document.querySelector('[data-cu-hoodie-product="' + HANDLE + '"]');
  if (!root || root.dataset.cuHoodieBound) return;
  root.dataset.cuHoodieBound = '1';
  var configNode = root.querySelector('#cu-hoodie-product-data');
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var form = root.querySelector('#cu-hoodie-product-form');
  var variantInput = form && form.querySelector('input[name="id"]');
  var variants = Array.isArray(config.variants) ? config.variants : [];
  var packageQuantities = [1, 2, 3, 6];
  var initialQuantity = Number(config.defaultQuantity);
  var state = { handle: HANDLE, variantId: String(config.selectedVariantId || ''), quantity: packageQuantities.indexOf(initialQuantity) === -1 ? 3 : initialQuantity, options: [], available: true };

  function dispatch(name) { root.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: getSelection() })); }
  function getSelection() { return { handle: state.handle, variantId: state.variantId, quantity: state.quantity, options: state.options.slice(), available: state.available }; }
  function selectedOptions() {
    return Array.from(root.querySelectorAll('[data-cu-hoodie-option]')).map(function (fieldset) {
      var selected = fieldset.querySelector('input:checked');
      return selected ? selected.value : null;
    });
  }
  function syncVariant(announce) {
    var chosen = selectedOptions();
    var match = variants.find(function (variant) {
      return !chosen.length ? String(variant.id) === state.variantId : chosen.every(function (value, index) { return !value || variant.options[index] === value; });
    });
    // Image-only PDP has no duplicate color/size controls; expose the actual
    // selected variant's options and leave the native COD selectors in charge.
    state.options = match && Array.isArray(match.options) ? match.options.slice() : chosen;
    state.available = !!(match && match.available);
    if (match) {
      state.variantId = String(match.id);
      if (variantInput) variantInput.value = String(match.id);
    }
    root.querySelectorAll('[data-cu-hoodie-option]').forEach(function (fieldset, i) {
      var label = fieldset.querySelector('[data-cu-hoodie-option-label]');
      if (label) label.textContent = chosen[i] || '';
    });
    var availability = root.querySelector('[data-cu-hoodie-availability]');
    if (availability) availability.textContent = state.available ? '' : 'Esta combinación no está disponible. Elige otra talla o color.';
    root.querySelectorAll('[data-cu-hoodie-open-cod]').forEach(function (button) { button.disabled = !state.available; });
    if (announce) {
      var colorIndex = (config.optionNames || []).findIndex(function (name) { return /colou?r/i.test(name); });
      var color = colorIndex >= 0 ? chosen[colorIndex] : chosen.find(function (value) { return galleryButtons.some(function (button) { return normalizeColor(button.dataset.cuHoodieGalleryColor) === normalizeColor(value); }); });
      var colorPhoto = color && galleryButtons.find(function (button) { return normalizeColor(button.dataset.cuHoodieGalleryColor) === normalizeColor(color); });
      if (colorPhoto) showGallery(colorPhoto);
      dispatch('cu:hoodie:selection-change');
    }
  }
  function setQuantity(quantity, announce) {
    var value = Number(quantity);
    if (packageQuantities.indexOf(value) === -1) return;
    state.quantity = value;
    root.querySelectorAll('[data-cu-hoodie-pack]').forEach(function (card) {
      var chosen = Number(card.dataset.cuHoodiePack) === value;
      card.classList.toggle('is-selected', chosen);
      var input = card.querySelector('input');
      if (input) input.checked = chosen;
    });
    // Native Releasit owns quantity, package discounts and submission totals.
    // Never write its hidden business inputs or manufacture discounted variants.
    if (announce) dispatch('cu:hoodie:pack-change');
  }
  root.addEventListener('change', function (event) {
    if (event.target.closest('[data-cu-hoodie-option]')) {
      event.stopPropagation();
      syncVariant(true);
    }
    if (event.target.name === 'cu-hoodie-pack') setQuantity(event.target.value, true);
  }, true);
  var heroVisual = root.querySelector('[data-cu-hoodie-hero-visual]');
  var heroPhoto = heroVisual && heroVisual.querySelector('img');
  var galleryButtons = Array.from(root.querySelectorAll('[data-cu-hoodie-gallery-src]'));
  function normalizeColor(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase(); }
  function showGallery(button) {
    if (!heroPhoto || !button) return;
    heroPhoto.removeAttribute('srcset');
    heroPhoto.removeAttribute('sizes');
    heroPhoto.src = button.dataset.cuHoodieGallerySrc;
    heroPhoto.alt = button.dataset.cuHoodieGalleryAlt || 'Foto real del producto';
    galleryButtons.forEach(function (item) { item.setAttribute('aria-pressed', item === button ? 'true' : 'false'); });
  }
  if (heroPhoto) galleryButtons.forEach(function (button) {
    button.setAttribute('aria-pressed', button.hasAttribute('data-cu-hoodie-gallery-cover') ? 'true' : 'false');
    button.addEventListener('click', function () { showGallery(button); });
  });
  root.querySelectorAll('[data-cu-hoodie-detail-gallery]').forEach(function (gallery) {
    var photo = gallery.querySelector('[data-cu-hoodie-detail-image]');
    if (!photo) return;
    var buttons = Array.from(gallery.querySelectorAll('[data-cu-hoodie-detail-src]'));
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        // Keep responsive candidates in sync with the selected genuine view.
        if (button.dataset.cuHoodieDetailSrcset) {
          photo.sizes = button.dataset.cuHoodieDetailSizes || '(min-width: 500px) 500px, 100vw';
          photo.srcset = button.dataset.cuHoodieDetailSrcset;
        } else {
          photo.removeAttribute('srcset');
          photo.removeAttribute('sizes');
        }
        photo.src = button.dataset.cuHoodieDetailSrc;
        photo.alt = button.dataset.cuHoodieDetailAlt || 'Vista de la prenda del proveedor';
        buttons.forEach(function (item) { item.setAttribute('aria-pressed', item === button ? 'true' : 'false'); });
      });
    });
  });
  if (form) form.addEventListener('submit', function (event) {
    // This form provides the real variant to the COD app, never a second checkout.
    event.preventDefault();
  });
  window.CosaUtilHoodie = Object.assign(window.CosaUtilHoodie || {}, { getSelection: getSelection, setQuantity: function (quantity) { setQuantity(quantity, true); } });
  setQuantity(state.quantity, false);
  syncVariant(false);
  dispatch('cu:hoodie:ready');
})();

